module.exports = __webpack_public_path__ + "img/8.a5955cf9.svg";